/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetAllIncidentFileFieldTypesParams,
  IReadOnlyListOfIncidentFileFieldTypeDto,
  IncidentFileFieldTypeDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all incidentfilefieldtype enumeration values, with an optional filter.
 */
export const getAllIncidentFileFieldTypes = (
    params?: GetAllIncidentFileFieldTypesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfIncidentFileFieldTypeDto>>,) => {
      return customInstance<IReadOnlyListOfIncidentFileFieldTypeDto>(
      {url: `/incident-management/incident-file-field-types`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the IncidentFileFieldType identified by the route id.
 */
export const getIncidentFileFieldTypeById = (
    id: number,
 options?: SecondParameter<typeof customInstance<IncidentFileFieldTypeDto>>,) => {
      return customInstance<IncidentFileFieldTypeDto>(
      {url: `/incident-management/incident-file-field-types/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllIncidentFileFieldTypesResult = NonNullable<Awaited<ReturnType<typeof getAllIncidentFileFieldTypes>>>
export type GetIncidentFileFieldTypeByIdResult = NonNullable<Awaited<ReturnType<typeof getIncidentFileFieldTypeById>>>
